module.exports = __webpack_public_path__ + "static/media/menu-projects-icon.3b705752.svg";